'use strict';



const $ = require('jquery');
const vex = require('vex-js');
const keycode = require('keycode');
const trigger = '.js-team-member';
const targets = '.js-team-member-content';
const vexInnerContent = '.js-team-member-inner-content';
const navigation = '.js-team-member-modal-navigation';
const navigationKeys = [ 'left', 'right' ];
const navigationFixedClassname = 'c-team-modal__navigation__item--fixed';
const navigationValues = { left: -1, right: 1 };
let active = null;
let $activeVex = null;



$('body').on('click', trigger, function(e) {

	e.preventDefault();

	const id = $(this).data('target') ?
		$(this).data('target') :
		getIndex($($(this).attr('href')));

	open(id);

});



$('body').on('keydown', e => {

	if(active === null) {
		return;
	}

	const direction = navigationKeys.find(key => key === keycode(e));

	if(direction) {
		openRelative(navigationValues[direction]);
		e.preventDefault();
	}

});



/**
 * Open
 *
 * Open a modal window for a particular team member.
 */
function open(id = 0) {

	const $target = getTarget(id);

	if($target.length < 1) {
		return false;
	}

	if(active !== null) {
		return updateContent(id);
	}

	active = id;

	vex.open({
		contentClassName: 'c-team-modal',
		unsafeContent: $target.html(),
		afterOpen($vex) {
			if($activeVex) {
				vex.close($activeVex.data().vex.id);
			}
			$activeVex = $(this.contentEl);
		},
		afterClose() {
			active = null;
			$activeVex = null;
		}
	});

	return true;

}



/**
 * Open Relative
 *
 * Open a team member modal relative to the one currently active.
 */
function openRelative(value = 1) {

	if(active === null) {
		return false;
	}

	const $targets = $(targets);
	let target = active + value;

	if(target < 0) {
		target = $targets.length - 1;
	}

	if(target === $targets.length) {
		target = 0;
	}

	return open(target);

}



/**
 * Update Content
 *
 * If a modal is already open, we update its content rather than closing it
 * and opening another.
 */
function updateContent(id = 0) {

	if(active === null) {
		return false;
	}

	const $target = getTarget(id);

	if($target.length < 1) {
		return false;
	}

	active = id;

	const $targetHtml = $target
		.find(vexInnerContent)
		.html();

	$activeVex
		.find(vexInnerContent)
		.html($targetHtml);

	return true;

}



function getIndex($target) {
	return $target.data('team-id');
}



function getTarget(id) {
	return $(`[data-team-id=${id}]`);
}